
const receiptsType = {
  RECEIPTS_TABLE_STATE_SET: 'RECEIPTS/TABLE_STATE_SET',
  RECEIPTS_TABLE_STATE_RESET: 'RECEIPTS/TABLE_STATE_RESET',
  RECEIPTS_SELECTED_ROWS_SET: 'RECEIPTS/SELECTED_ROWS_SET',
};
export default receiptsType;